import { buildApiUrl, serverFetch } from "@core/server";

export function fetchHealthClients(filters) {
  const queryParams = {
    periodType: filters.periodType ?? 0,
    onlyInComplex: Boolean(filters.onlyInComplex),
    idSotr: filters.idSotr ?? 0,
    skip: filters.skip ?? 0,
    take: filters.take ?? 100,
    sortField: filters.sortField || "name",
    sortOrder: filters.sortOrder || "asc"
  };

  if (filters.dateBeg) queryParams.dateBeg = filters.dateBeg;
  if (filters.dateEnd) queryParams.dateEnd = filters.dateEnd;
  if (filters.name?.trim()) queryParams.name = filters.name.trim();

  return serverFetch("health/clients", { queryParams });
}

export function fetchHealthDoctors() {
  return serverFetch("health/clients/doctors");
}

export function fetchClientImportStatus() {
  return serverFetch("health/clients/import");
}

export function fetchClientImportGuests() {
  return serverFetch("health/clients/import/guests");
}

export function importHealthClients(extraIds) {
  return serverFetch("health/clients/import", {
    method: "POST",
    bodyData: { extraIds }
  });
}

export function fetchHealthSocGroups() {
  return serverFetch("health/clients/soc-groups");
}

export function fetchHealthClient(idClient) {
  return serverFetch(`health/clients/${idClient}`);
}

export function createHealthClient(bodyData) {
  return serverFetch("health/clients", {
    method: "POST",
    bodyData
  });
}

export function saveHealthClient(idClient, bodyData) {
  return serverFetch(`health/clients/${idClient}`, {
    method: "PUT",
    bodyData
  });
}

export function deleteHealthClient(idClient) {
  return serverFetch(`health/clients/${idClient}`, { method: "DELETE" });
}

export function fetchHealthClientUsl(idClient) {
  return serverFetch(`health/clients/${idClient}/usl`);
}

export function createHealthClientUsl(idClient, bodyData) {
  return serverFetch(`health/clients/${idClient}/usl`, {
    method: "POST",
    bodyData
  });
}

export function updateHealthClientUsl(idClient, bodyData) {
  return serverFetch(`health/clients/${idClient}/usl`, {
    method: "PUT",
    bodyData
  });
}

export function deleteHealthClientUsl(idClient, idStr) {
  return serverFetch(`health/clients/${idClient}/usl/${idStr}`, {
    method: "DELETE"
  });
}

export function fetchHealthClientUslPay(idClient) {
  return serverFetch(`health/clients/${idClient}/usl/pay`);
}

export function postHealthClientUslPay(idClient, bodyData) {
  return serverFetch(`health/clients/${idClient}/usl/pay`, {
    method: "POST",
    bodyData
  });
}

export {
  fetchSprTemplateNaznList as fetchHealthUslTemplates,
  fetchSprTemplateNaznItems as fetchHealthUslTemplateItems
} from "@components/sprs/template-nazn/spr-template-nazn-api";

export function applyHealthUslTemplate(idClient, idShb) {
  return serverFetch(`health/clients/${idClient}/usl/from-template`, {
    method: "POST",
    bodyData: { idShb }
  });
}

export function fetchHealthPlanDays(idClient, idStr) {
  return serverFetch(`health/clients/${idClient}/usl/${idStr}/plan-days`);
}

export function fetchHealthPlanDaySessions(idClient, idStr, date) {
  return serverFetch(`health/clients/${idClient}/usl/${idStr}/plan-days/sessions`, {
    queryParams: { date }
  });
}

export function fetchHealthPlanTimeHalls(idClient, idStr, { dateBeg, dateEnd } = {}) {
  const queryParams = {};
  if (dateBeg) queryParams.dateBeg = dateBeg;
  if (dateEnd) queryParams.dateEnd = dateEnd;
  return serverFetch(`health/clients/${idClient}/usl/${idStr}/plan-days/halls`, { queryParams });
}

export function fetchHealthPlanTimeSlots(idClient, idStr, date, idZal = 0) {
  return serverFetch(`health/clients/${idClient}/usl/${idStr}/plan-days/free-slots`, {
    queryParams: { date, idZal }
  });
}

export function addHealthPlanByTime(idClient, idStr, items) {
  return serverFetch(`health/clients/${idClient}/usl/${idStr}/plan-days/by-time`, {
    method: "POST",
    bodyData: { items }
  });
}

export function fetchHealthClientDayPlan(idClient, { dateBeg, dateEnd, date, all } = {}) {
  const queryParams = {};
  if (dateBeg) queryParams.dateBeg = dateBeg;
  if (dateEnd) queryParams.dateEnd = dateEnd;
  if (date) queryParams.date = date;
  if (all) queryParams.all = true;
  return serverFetch(`health/clients/${idClient}/day-plan`, { queryParams });
}

export function addHealthPlanDays(idClient, idStr, items) {
  return serverFetch(`health/clients/${idClient}/usl/${idStr}/plan-days`, {
    method: "POST",
    bodyData: { items }
  });
}

export function deleteHealthPlanDays(idClient, idStr, items) {
  return serverFetch(`health/clients/${idClient}/usl/${idStr}/plan-days`, {
    method: "DELETE",
    bodyData: { items }
  });
}

export function postHealthAutoPlan(idClient, bodyData) {
  return serverFetch(`health/clients/${idClient}/auto-plan`, {
    method: "POST",
    bodyData
  });
}

export function fetchHealthClientHistory(idClient) {
  return serverFetch(`health/clients/${idClient}/history`);
}

export function saveHealthClientHistory(idClient, sections) {
  return serverFetch(`health/clients/${idClient}/history`, {
    method: "PUT",
    bodyData: { sections }
  });
}

export function fetchHealthHistoryPhrases(q) {
  const queryParams = {};
  if (q?.trim()) queryParams.q = q.trim();
  return serverFetch("health/clients/history-phrases", { queryParams });
}

/** Типовая форма (id_client = 0). */
export function fetchHealthHistoryTemplate() {
  return serverFetch("health/clients/history-template");
}

export function saveHealthHistoryTemplate(sections) {
  return serverFetch("health/clients/history-template", {
    method: "PUT",
    bodyData: { sections }
  });
}

export function fetchHealthClientDiagnosis(idClient) {
  return serverFetch(`health/clients/${idClient}/diagnosis`);
}

export function fetchHealthClientDiagnosisEntry(idClient, idStr) {
  return serverFetch(`health/clients/${idClient}/diagnosis/${idStr}`);
}

export function createHealthClientDiagnosis(idClient, bodyData) {
  return serverFetch(`health/clients/${idClient}/diagnosis`, {
    method: "POST",
    bodyData
  });
}

export function updateHealthClientDiagnosis(idClient, idStr, bodyData) {
  return serverFetch(`health/clients/${idClient}/diagnosis/${idStr}`, {
    method: "PUT",
    bodyData
  });
}

export function deleteHealthClientDiagnosis(idClient, idStr) {
  return serverFetch(`health/clients/${idClient}/diagnosis/${idStr}`, {
    method: "DELETE"
  });
}

export function fetchHealthDiagnosisTypes() {
  return serverFetch("health/clients/diagnosis-types");
}

export function fetchHealthDiagnosisCatalog(q) {
  const queryParams = {};
  if (q?.trim()) queryParams.q = q.trim();
  return serverFetch("health/clients/diagnosis-catalog", { queryParams });
}

export function fetchHealthClientDiary(idClient) {
  return serverFetch(`health/clients/${idClient}/diary`);
}

export function fetchHealthClientDiaryEntry(idClient, idStr) {
  return serverFetch(`health/clients/${idClient}/diary/${idStr}`);
}

export function createHealthClientDiary(idClient, bodyData) {
  return serverFetch(`health/clients/${idClient}/diary`, {
    method: "POST",
    bodyData
  });
}

export function updateHealthClientDiary(idClient, idStr, bodyData) {
  return serverFetch(`health/clients/${idClient}/diary/${idStr}`, {
    method: "PUT",
    bodyData
  });
}

export function deleteHealthClientDiary(idClient, idStr) {
  return serverFetch(`health/clients/${idClient}/diary/${idStr}`, {
    method: "DELETE"
  });
}

export function approveHealthClientDiary(idClient, idStr, approve = true) {
  return serverFetch(`health/clients/${idClient}/diary/${idStr}/approve`, {
    method: "POST",
    bodyData: { approve }
  });
}

export function fetchHealthDiaryVisitTypes() {
  return serverFetch("health/clients/diary-visit-types");
}

export function fetchHealthDiaryConditions() {
  return serverFetch("health/clients/diary-conditions");
}

/** CDA-экспорт: скачивает XML (как AHisExport в Delphi). */
export async function exportHealthClientDiaryCda(idClient, idStr) {
  const url = buildApiUrl(`health/clients/${idClient}/diary/${idStr}/cda`);
  const headers = new Headers({ Accept: "application/xml, application/json" });
  const sessionId = localStorage.getItem("sessionId");
  if (sessionId) headers.append("sessionId", sessionId);

  const response = await fetch(url, {
    method: "POST",
    credentials: "include",
    headers
  });

  const contentType = response.headers.get("content-type") || "";
  if (!response.ok) {
    let message = "Не удалось сформировать CDA";
    if (contentType.includes("application/json")) {
      const err = await response.json();
      message = err?.userMessage || err?.message || message;
    } else {
      const text = await response.text();
      if (text) message = text;
    }
    throw new Error(message);
  }

  const blob = await response.blob();
  const disposition = response.headers.get("content-disposition") || "";
  const match = /filename\*?=(?:UTF-8''|")?([^";]+)/i.exec(disposition);
  const fileName = match
    ? decodeURIComponent(match[1].replace(/"/g, ""))
    : `proffit-${idClient}-${idStr}.xml`;
  return { blob, fileName };
}

export function fetchSprTov(q) {
  const queryParams = {};
  if (q?.trim()) queryParams.q = q.trim();
  return serverFetch("sprtov", { queryParams });
}

export function fetchSprSotr(q) {
  const queryParams = {};
  if (q?.trim()) queryParams.q = q.trim();
  return serverFetch("sprsotr", { queryParams });
}
